/**
 * Isophi portals
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * * `DIRECT_ADDED` - Direct Added * `VALIDATED` - Validated * `RESEND` - Resend * `DELETED` - Deleted * `CREATED` - Created
 */
export type InvitationCodeEnum = 'DIRECT_ADDED' | 'VALIDATED' | 'RESEND' | 'DELETED' | 'CREATED';

export const InvitationCodeEnum = {
    DIRECTADDED: 'DIRECT_ADDED' as InvitationCodeEnum,
    VALIDATED: 'VALIDATED' as InvitationCodeEnum,
    RESEND: 'RESEND' as InvitationCodeEnum,
    DELETED: 'DELETED' as InvitationCodeEnum,
    CREATED: 'CREATED' as InvitationCodeEnum
};